export default {
    chooseLists: 'Choose lists',
    listDescription: 'List information is available only to you and your company.',
    searchPlaceholder: 'search by list names',
    createList: 'Create new list',
    save: 'save',
    saved: 'Saved'

};
